import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

// Protected Route - requires authentication
export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) =>
        auth.isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/trade_app/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

// Admin Route - requires authentication and ADMIN role
export const AdminRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.isLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: "/trade_app/login",
                state: { from: props.location },
              }}
            />
          );
        }

        if (auth.role?.toUpperCase() !== "ADMIN") {
          return (
            <Redirect
              to={{
                pathname: "/trade_app/unauthorized",
                state: { from: props.location },
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};

// Unauthorized Page Component
export const Unauthorized = () => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">🚫</div>
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <p>This feature is only available for administrators.</p>
        <a href="/trade_app/home" className="btn btn-primary">
          Go to Home
        </a>
      </div>
      <style>{`
        .unauthorized-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 60vh;
        }
        .unauthorized-card {
          background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
          border-radius: 16px;
          padding: 48px;
          text-align: center;
          color: #e2e8f0;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          max-width: 400px;
        }
        .unauthorized-icon {
          font-size: 64px;
          margin-bottom: 24px;
        }
        .unauthorized-card h2 {
          color: #f87171;
          margin-bottom: 16px;
          font-size: 28px;
        }
        .unauthorized-card p {
          color: #94a3b8;
          margin-bottom: 12px;
        }
        .unauthorized-card .btn {
          margin-top: 24px;
          padding: 12px 32px;
          background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
          border: none;
          border-radius: 8px;
          color: white;
          font-weight: 600;
          text-decoration: none;
          display: inline-block;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .unauthorized-card .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px -5px rgba(6, 182, 212, 0.4);
        }
      `}</style>
    </div>
  );
};

export default ProtectedRoute;

